function updateCustomPayments() {
  const mainCartItems = document.querySelector('#mainExpressCheckout');
  const footerExpressCheckout = document.querySelector('#footerExpressCheckout');
  const cartFooterWrapper = document.querySelector('.cart__footer-wrapper');
  const separator = cartFooterWrapper?.querySelector('.separator');
  const additionalCheckoutButtons = footerExpressCheckout?.querySelector('.ob-dynamic-btn-cart');
  const legalNoticeFooter = additionalCheckoutButtons?.nextElementSibling;
  const topSeparator = document.querySelector('.main-cart-payment-wrapper .separator');

  if (window.innerWidth <= 500) {
    // Check if the elements are already in the main cart items to avoid unnecessary removal
    if (!mainCartItems.contains(additionalCheckoutButtons) && additionalCheckoutButtons) {
      mainCartItems.appendChild(additionalCheckoutButtons);
    }
    if (!mainCartItems.contains(legalNoticeFooter) && legalNoticeFooter) {
      mainCartItems.appendChild(legalNoticeFooter);
    }

    // Hide separator and adjust footerExpressCheckout margin
    if (separator) {
      separator.style.display = 'none';
    }

    footerExpressCheckout.style.setProperty('margin-top', '20px', 'important');
  } else {
    if (topSeparator) {
      topSeparator.style.display = 'none';
    }
  }
}

// Run on initial load
updateCustomPayments();

// Run on window resize
window.addEventListener('resize', updateCustomPayments);

// for accessibility and styling
function setMobileTabOrder() {
  const cartItems = document.querySelector('.main-cart-items cart-items');
  const uspBlocks = document.querySelector('.main-cart-items .usp-wrapper');

  if (!cartItems || !uspBlocks) {
    console.error('Elements not found'); // Debugging help
    return;
  }

  if (window.innerWidth <= 1000) {
    // Reorder elements in DOM for mobile
    uspBlocks.parentNode.insertBefore(uspBlocks, cartItems);
  } else {
    // Reorder elements back for larger screens (original order)
    cartItems.parentNode.insertBefore(cartItems, uspBlocks);
  }
}

// Call the function on load and on window resize
window.addEventListener('resize', setMobileTabOrder);
window.addEventListener('DOMContentLoaded', setMobileTabOrder);